import { Button, Dialog, DialogContent, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { makeStyles } from "tss-react/mui";
import { CheckCircle } from "@mui/icons-material";
import { useForm } from "../../../providers/FormProvider";
import { useDevice } from "../../../providers/DeviceProvider";

const useStyles = makeStyles()(
  (theme) => ({
    dialog: {
      "& .MuiDialog-paperFullScreen": {
        borderRadius: 0,
      }
    },
    checkCircle: {
      width: "108px",
      height: "108px",
      color: theme.palette.success.main
    },
    button: {
      padding: theme.spacing(3),
      "@media (max-width: 500px)": {
        padding: theme.spacing(3.5)
      }
    },
    stack: {
      width: "100%"
    }
  })
);

export default function ConfirmationDialog() {
  const { t } = useTranslation();
  const { classes } = useStyles();
  const { slim } = useDevice();

  const {
    customerEmail,
    copyForm,
    makeNewEmptyForm,
    referenceNumber,
  } = useForm();

  return (
    <Dialog
      open
      className={classes.dialog}
      fullWidth
      fullScreen

    >
      <DialogContent sx={{ alignItems: "center", justifyContent: "center", display: "flex" }}>
        <Stack alignItems="center" spacing={4} padding={slim ? 1.5 : 3.5} sx={{ maxWidth: "500px", marginBottom: 8 }}>

          <CheckCircle className={classes.checkCircle} />

          <Stack spacing={1.5} className={classes.stack}>
            <Typography variant="h6" textAlign="center">{t("confirmationDialog:title")}</Typography>

            <Typography variant="body1" textAlign="center">
              {t("confirmationDialog:descriptionPart1")}
              &nbsp;{customerEmail}
              {t("confirmationDialog:descriptionPart2")}
            </Typography>

            <Typography variant="body1" textAlign="center" color="textSecondary">{t("confirmationDialog:reference")}: {referenceNumber}</Typography>
          </Stack>

          <Stack spacing={1.5} className={classes.stack}>

            <Button variant="contained" fullWidth size="large" color="neutral" onClick={makeNewEmptyForm} className={classes.button}>
              {t("confirmationDialog:newEmpty")}
            </Button>

            <Button variant="contained" fullWidth size="large" color="neutral" onClick={copyForm} className={classes.button}>
              {t("confirmationDialog:copy")}
            </Button>
          </Stack>

        </Stack>
      </DialogContent>
    </Dialog >
  );
}